import { Box, Text } from '@rbilabs/universal-components';

export const Container = Box.withConfig({
  width: 'full',
  alignItems: 'center',
  justifyContent: 'center',
});

export const Heading = Text.withConfig({
  focusable: true,
  accessible: true,
  variant: 'headerOne',
  margin: 0,
  padding: 0,
});

export const Content = Text.withConfig({
  focusable: true,
  accessible: true,
  variant: 'copyOne',
  textAlign: 'center',
  marginY: '$4',
});
